// Get the maximum number of columns based on the column width
export default function (columnWidth) {
    const columnMaxWidths = {
        12: {
            mobileLandscape: 2,
            tablet: 3,
            desktop: 4,
        },
        8: {
            mobileLandscape: 2,
            tablet: 2,
            desktop: 2,
        },
        6: {
            mobileLandscape: 2,
            tablet: 2,
            desktop: 2,
        },
        4: {
            mobileLandscape: 1,
            tablet: 1,
            desktop: 1,
        },
        3: {
            mobileLandscape: 1,
            tablet: 1,
            desktop: 1,
        },
    }

    return columnMaxWidths[columnWidth]
}
